<template>
  <div class="footer">
    Copyright @ 2023 恩兆資訊有限公司 All rights reserved
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>